export type Action = {
  actionName: string;
  token: string;
  expires_at: string;
};

export type ResponseMessage = {
  message: string;
}

export interface ActionsMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  doAction(
    token: string,
    params: Record<string, any>
  ): Promise<ResponseMessage>;
}
export const ActionsMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async doAction(
    token: string,
    params: Record<string, any>
  ):  Promise<ResponseMessage> {
    const res = await this.fetch("/actions", {
      method: "post",
      body: JSON.stringify({
        token: token, ...params
      })
    });
    return res;
  },
} as ActionsMixin;
